<template>
    <div class="login-form">
        <div class="choose_login_type">
            <div
                v-for="item in loginTabList"
                :class="loginType == item.value ? 'active' : ''"
                :key="item.value"
                @click="chooseType(item.value)"
            >{{ item.label }}</div>
        </div>
        <el-form
            :model="dataForm"
            :rules="dataRule"
            ref="dataForm"
            @keyup.enter.native="dataFormSubmit()"
            status-icon
        >
            <ul class="login-ul" :class="loginType === 3?'phoneLogin':''">
                <template v-if="loginType === 1">
                    <li class="login-li radius3">
                        <!-- <i class="login-user"></i> -->
                        <el-form-item prop="userName">
                            <el-input
                                v-model.trim="dataForm.userName"
                                clearable
                                placeholder="请输入帐号/用户名"
                            ></el-input>
                        </el-form-item>
                    </li>
                    <li class="login-li radius3">
                        <!-- <i class="login-pwd"></i> -->
                        <el-form-item prop="password">
                            <el-tooltip
                                v-model="capsTooltip"
                                content="已开启大写"
                                placement="top"
                                manual
                            >
                                <el-input
                                    v-model.trim="dataForm.password"
                                    @keyup.native="checkCapslock"
                                    clearable
                                    type="password"
                                    placeholder="请输入密码"
                                    show-password
                                ></el-input>
                            </el-tooltip>
                        </el-form-item>
                    </li>
                    <!-- <li class="captcha-box" v-if="hasCaptcha">
                        <el-form-item prop="captcha">
                            <el-row :gutter="20">
                                <el-col :span="14">
                                    <el-input v-model="dataForm.captcha" placeholder="验证码"></el-input>
                                </el-col>
                                <el-col :span="10" class="login-captcha">
                                    <img :src="captchaPath" @click="getCaptcha()" alt />
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </li> -->
                    <li class="login-li radius3" >
                  <slideVerify id="slideVerifyRef" ref="slideVerifyRef" :show="slideVerifyShow" :canvasWidth="424" limitMoveBox="loginBox" :sliderSize="36"
                    :canvasHeight="180" :vwh="40" @success="slideVerifySuccss" @fail="slideVerifyFail"></slideVerify>
                </li>

                </template>

                <template v-if="loginType === 2">
                    <li>
                        <div class="lock-box">
                            <div class="lock"></div>
                            <p class="sizi">请插入CA锁后点击登录</p>
                            <!-- <el-button class="login-btn radius3" style="padding: 0px 0px;" type="primary"
                            @click="dialogVisible = true">登录
                            </el-button>-->
                        </div>
                    </li>
                </template>
                <template v-if="loginType === 3">
                    <li class="login-li radius3">
                        <!-- <i class="el-icon-phone"></i> -->
                        <el-form-item prop="userPhone">
                            <el-input v-model="dataForm.userPhone" placeholder="手机号"></el-input>
                        </el-form-item>
                    </li>
                    <li class="login-li radius3">
                        <el-form-item prop="captcha">
                            <el-row >
                                <el-col :span="14">
                                    <el-input v-model="dataForm.captcha" placeholder="图片验证码" class="noRightBorder"></el-input>
                                </el-col>
                                <el-col :span="10" class="login-captcha">
                                    <img
                                        :src="captchaPath"
                                        @click="getCaptcha()"
                                        alt
                                        style="width:100%;height:48px;"
                                    />
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </li>
                    <li class="login-li radius3 ">
                        <!-- <i class="el-icon-message"></i> -->
                        <el-form-item prop="userCaptcha"  class="duanxin">
                            <el-row>
                                <el-col :span="14">
                                    <el-input v-model="dataForm.userCaptcha" placeholder="短信验证码" class="noRightBorder"></el-input>
                                </el-col>
                                <el-col :span="10" class="login-captcha">
                                    <template v-if="captchaText">
                                        <el-button
                                            class="noLeftBorder"
                                            style="width:100%;height:48px;"
                                            @click="getCaptchaPhone"
                                            :disabled="dataForm.captcha == ''"
                                        >获取验证码</el-button>
                                    </template>
                                    <template v-else>
                                        <el-button style="width:100%;">{{ captchaNum }} s</el-button>
                                    </template>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </li>
                </template>

                <li>
                    <el-form-item style="text-align:center;margin-top: 24px;">
                        <template>
                            <template v-if="loginFg">
                                <el-button
                                    class="login-btn radius3"
                                    type="primary"
                                    style="padding: 0px 0px;"
                                    :disabled="(loginType == 1) && !slideVerifyPass"
                                    @click="dataFormSubmit()"
                                >登录</el-button>
                            </template>
                            <template v-else>
                                <el-button class="login-btn radius3" type="primary" disabled>登录中 ···</el-button>
                            </template>
                        </template>
                        <el-link
                            class="linksty"
                            :underline="false"
                            target="_blank"
                            v-if="loginType == 1&&showResetPwBtn && $settings.system_resetPw_link"
                            :href="$settings.system_resetPw_link"
                        >
                            <span>忘记密码 ？</span>
                        </el-link>
                    </el-form-item>
                </li>
            </ul>
        </el-form>

        <!-- <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
            <el-input v-model="dataForm.captcha" placeholder="请输入口令"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>-->
    </div>
</template>
<script>
import { getUUID, aesEncrypt, IsIE, setSessionStorage } from "@/utils";
import axios from "axios";
import loginHttp from "@/utils/login";
import VueCookie from "vue-cookie";
import { ca } from "pm-utils";
import slideVerify from "./components/slideVerify";
const ssoHttp = axios.create({
    timeout: 1000 * 30,
    withCredentials: true,
    headers: {
        "X-Requested-With": "XMLHttpRequest",
        X_PROXY_GATEWAY: true,
        X_PROXY_REST: true,
        "Content-Type": "application/json; charset=utf-8"
    }
});

export default {
    components:{
        slideVerify
    },
    data() {
        //验证手机号的规则;
        const checkMobile = (rule, value, cb) => {
            // 验证手机号的正则表达式
            const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
            if (regMobile.test(value)) {
                return cb();
            }
            cb(new Error("请输入合法的手机号"));
        };
        return {
            signType: 1,
            hasCaptcha: false,
            show: 1,
            capsTooltip: false,
            dialogVisible: false,
            dataForm: {
                userName: "",
                password: "",
                uuid: "",
                captcha: "", // 图片验证码
                userPhone: "",
                userCaptcha: "" //用户输入的手机号验证码
            },
            dataRule: {
                userName: [
                    { required: true, message: "帐号不能为空", trigger: "blur" }
                ],
                password: [
                    { required: true, message: "密码不能为空", trigger: "blur" }
                ],
                captcha: [
                    {
                        required: true,
                        message: "验证码不能为空",
                        trigger: "blur"
                    }
                ],
                userPhone: [
                    { required: true, message: '请输入正确的手机号', validator: checkMobile, trigger: 'blur' }
                ],
                userCaptcha: [
                    { required: true, max: 6, min: 6, message: '请输入正确的验证码', validator: '/^[0-9]*$/', trigger: 'blur' }
                ]
            },
            captchaPath: "",
            slideVerifyPass: true,
            captchaText: true, //获取验证码按钮文字数字
            captchaNum: 59, //验证码倒计时
            loginFg: true, //正在登陆中
            loginMethod: "compute",
            showTootip: true,
            loginType: 1, //账号密码loginType=1，2 ca登录  3（手机号+验证码），
            loginTabList: [
                {
                    label: "帐号登录",
                    value: 1
                },
                {
                    label: "CA登录",
                    value: 2
                },
                {
                    label: "手机号登录",
                    value: 3
                }
            ],
            slideVerifyShow: false
        };
    },
    created() {

        if (top.location != self.location) {  // 本页面被嵌套时，父页面跳转到登录页
            window.parent.postMessage('logout', '*')
        }

        if (this.hasCaptcha) {
            this.getCaptcha();
        } else {
            ssoHttp.get("/api/hasCaptcha", {}).then(({ data }) => {
                if (data && data.code === "1" && data.data == true) {
                    this.getCaptcha();
                }
            });
        }
    },

    computed: {
        showRegisterBtn: {
            get() {
                return (
                    this.$settings.system_register_link != "undefined" &&
                    this.$settings.system_register_link != ""
                );
            }
        },
        showResetPwBtn: {
            get() {
                return (
                    this.$settings.system_resetPw_link != "undefined" &&
                    this.$settings.system_resetPw_link != ""
                );
            }
        },

        showResetPwUrl: {
            get() {
                return this.$settings.system_resetPw_link;
            }
        }
    },
    mounted() {
        let token = this.$route.query["token"];
        if (token) {
            this.$cookie.set("access_token", token);
            this.loginByJwt(token);
        }
        this.$nextTick(() => {
            this.$refs.slideVerifyRef.init();
        });

        setTimeout(() => {
            this.$forceUpdate();
        }, 500);
    },
    methods: {
        slideVerifySuccss() {
            this.slideVerifyPass = true;
        },
        slideVerifyFail() {
            this.slideVerifyPass = false;
        },

        getCaptchaPhone() {
            //获取手机号验证码
            if (this.captchaText == false) {
                return;
            }
            ssoHttp({
                url: `/sso/sendphone/sendcaptcha?captcha=${this.dataForm.captcha}&phone=${this.dataForm.userPhone}&type=0`,
                method: "post"
            }).then(({ data }) => {
                if (data && data.code == "1") {
                    this.$message.success(data.msg);

                    this.captchaText = false;
                    var that = this;
                    this.time = setInterval(function() {
                        if (that.captchaNum == 1) {
                            clearInterval(that.time);
                            that.captchaText = true;
                            that.captchaNum = 59;
                            return;
                        }
                        that.captchaNum -= 1;
                    }, 1000);
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 选择登录方式
        chooseType(num) {
            this.$nextTick(() => {
                this.$refs.dataForm.resetFields();
            });
            this.loginType = num;
            if (this.loginType == 3) {
                // 获取验证码
                this.getCaptcha();
            }
        },
        // 提交表单
        dataFormSubmit() {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    let data = {};
                    if (this.loginType == 1) {
                        data = {
                            backUrl: "",
                            loginType: 0,
                            useCaptcha: 1,
                            appCode: window.SITE_CONFIG.appCode,
                            username: this.dataForm.userName,
                            password: aesEncrypt(this.dataForm.password),
                            uuid: this.dataForm.uuid,
                            captcha: this.dataForm.captcha
                        };
                        if(!this.slideVerifyPass){
                            this.$message.error('请先通过图片验证。');
                            return
                        }
                        this.loginFn(data).then(() => {}).catch(() => {
                            this.slideVerifyPass = false;
                            this.slideVerifyShow = true;
                        })
                    } else if (this.loginType == 3) {
                        data = {
                            appId: this.$settings.appId,
                            unAppEnabled: true,
                            backUrl: "",
                            loginType: 6,
                            useCaptcha: 1,
                            username: this.dataForm.userPhone,
                            password: this.dataForm.userCaptcha,
                            uuid: this.dataForm.uuid,
                            captcha: this.dataForm.captcha,
                            traddingOrgId: this.dataForm.tradeOrgId
                        };
                        this.loginFn(data);
                    } else if (this.loginType == 2) {
                        this.HBTMCALoginClick();
                    } else {
                        return false;
                    }
                }
            });
        },

        HBTMCALoginClick() {
            // 使用 pm-utils CA工具登录

            if (!IsIE()) {
                this.$message.error("ca登录请换ie浏览器");
                return;
            }

            try {
                const Ca = new ca.HuBeiTianMenHuren();
                const caToken = Ca.checkCaToken();
                if (!caToken) {
                    this.$message.error(
                        "未获取到CA信息，请检查CA锁并正确输入密码。"
                    );
                    return;
                } else {
                    this.dataForm.caCode = Ca.getCaSerialNumber();
                    this.dataForm.signdata = Ca.getCaSignData();
                    this.dataForm.username = "ca";
                    this.dataForm.password = "";
                    this.caLogin();
                }
            } catch (error) {
                this.loginFg = true;
                this.$alert("请检查CA驱动是否安装成功,请确保CA锁插入状态并正确输入密码！", "提示", {
                    confirmButtonText: "确定"
                });
            }
        },
        caLogin() {
            if (this.dataForm.signdata) {
                let patams = Object.assign({}, this.dataForm, {
                    traddingOrgId: this.dataForm.tradeOrgId,
                    'appId': this.$settings.appId,
                    'loginType': 1,
                });
                this.loginFn(patams, true);
            }
        },
        loginFn(data, caLoginFlag) {
            this.loginFg = false;
            return new Promise((resolve, reject) => {
                loginHttp
                    .post("/login", data)
                    .then(({ data }) => {
                        if (data && data.code === "1") {
                            this.loginFg = true;

                            this.$cookie.set("access_token", data.authCode);
                            this.loginByJwt(data.authCode);

                            if (caLoginFlag) {
                                let caInfo = {
                                    caCode: this.dataForm.caCode,
                                    signData: this.dataForm.signData
                                };
                                setSessionStorage("caInfo", caInfo);
                            }
                            resolve(true)
                        } else if (data && data.code == '1099') {
                            this.$message.error(data.msg);
                            setTimeout(()=>{
                                window.location.href = data.data + '&redirect_url=' + window.location.href;
                            },1000)
                        } else {
                            this.hasCaptcha = true;
                            this.getCaptcha();
                            this.$message.error(data.msg);
                            reject()
                        }
                    })
                    .catch(err => {
                        this.$message.error(err);
                        reject(false)
                    })
                    .finally(() => {
                        this.loginFg = true;
                    });
            });
        },
        // 获取验证码
        getCaptcha() {
            // 图片验证码与短信验证码必须使用sso统一使用基础平台的才能校验
            this.dataForm.uuid = getUUID();
            this.captchaPath = `/sso/captchaCode.png?uuid=${this.dataForm.uuid}`
        },
        // 开启大写提示
        checkCapslock({ shiftKey, key } = {}) {
            if (key && key.length === 1) {
                if (
                    (shiftKey && key >= "a" && key <= "z") ||
                    (!shiftKey && key >= "A" && key <= "Z")
                ) {
                    this.capsTooltip = true;
                } else {
                    this.capsTooltip = false;
                }
            }
            if (key === "CapsLock" && this.capsTooltip === true) {
                this.capsTooltip = false;
            }
        },
        loginByBxtFn(responseData) {
            loginByBxt(this.$http, {
                openId: responseData.openId
            }).then(({ data }) => {
                if (data.code == "1001") {
                    this.$message.error(data.msg);
                    return;
                }
                sessionStorage.setItem("oauth_access_token", value);
                sessionStorage.setItem("access_token", value);
                localStorage.setItem('access_token', value);
                localStorage.setItem("oauth_access_token", value);
                VueCookie.set(
                    "oauth_access_token",
                    data.data.authCode || data.authCode || ""
                );
                // this.handleRedirect(data.data.authCode || data.authCode || '')
            });
        },
        loginByJwt(token) {
            this.$http
                .post("/oauth/tokenLogin?token=" + token, {
                    token: token
                })
                .then(({ data }) => {
                    if (data.code === "1") {
                        let url = this.$route.query.redirect_uri;
                        if (url) {
                            // 由于ajax调用，不能回退到原来地址.
                            this.$router.push({ name: "home" });
                        } else {
                            this.$router.push({ name: "home" });
                        }
                    } else {
                        this.$message.error(data.msg);
                    }
                });
        },
        open() {
            this.$prompt("请输入口令", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消"
            })
                .then(() => {
                    return;
                })
                .catch(() => {});
        }
    }
};
</script>
<style lang="less">
.centerRight .login-li .el-input--medium .el-input__inner {
    height: 48px;
    line-height: 48px;
}
.centerRight .login-li .el-form-item{
    margin-bottom: 32px;
}
.centerRight  .phoneLogin .login-li .el-form-item{
    margin-bottom: 24px;
}
.centerRight .phoneLogin .login-li .el-form-item.duanxin{
    margin-bottom: 28px;
}
.centerRight .noRightBorder  .el-input__inner  {
    border-radius:0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
.centerRight .noLeftBorder  {
    color: #2568EC;
    border-radius:0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
.centerRight .duanxin .el-button:hover {
    color: #2568EC;
}
.centerRight .duanxin .el-button:focus {
    color: #2568EC;
}
</style>
<style lang="less" scoped>
.loginMethodImg {
    width: 52px;
    position: absolute;
    right: 10px;
    top: 10px;
}

.linksty {
    span {
        color: #2568ec;
    }
}

.container {
    .centerLeft {
        background-size: 81% auto;
        width: 600px;
    }

    .centerRight {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 440px;
        height: 100%;
        padding: 16px 50px 0 50px;
        box-shadow: 0px 1px 6px 0px rgba(33, 113, 251, 0.3);
        box-sizing: border-box;

        p.sizi {
            font-size: 18px;
        }
        .choose_login_type {
            margin-bottom: 8px;
            display: flex;
            justify-content: space-around;
            align-items: center;

            div {
                color: #4c4c4c;
                font-size: 16px;
                line-height: 35px;
                padding: 0 10px;
                cursor: pointer;
            }

            .active {
                border-bottom: 2px solid #2568EC;
                color: #2568EC;
            }
        }

        .my_ca {
            height: 100%;

            .ca_border {
                height: 194px;
                line-height: 194px;

                > div {
                    width: 220px;
                    height: 100%;
                    margin: 0 auto;
                    border: 1px solid #dcdfe6;
                    text-align: center;

                    img {
                        width: 120px;
                        height: 150px;
                    }
                }
            }
        }
    }

    .centerRight p {
        font-size: 30px;
        line-height: 28px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #3a3a3a;
        text-indent: 20px;
    }

    .centerRight .login-form .el-form-item__label {
        color: #333333;
        font-size: 20px;
        padding-left: 10px;
    }

    .centerRight .login-form .el-form-item__label:before {
        display: none;
    }

    // .centerRight .login-form .login-li .el-input__inner {
    //     height: 40px;
    //     line-height: 40px;
    //     padding-left: 30px;
    // }

    .centerRight .login-form .forget_pwd {
        text-align: right;
    }

    .centerRight .login-btn {
        width: 100%;
        height: 48px;
        background: #2568EC;
        border-radius: 2px;
        border: 0;
        outline: 0;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        cursor: pointer;

        &:hover {
            background: #4683ff;
        }

        &:active {
            background: #2568EC;
        }
    }

    .centerRight .login-btn.is-disabled {
        background: #bae7ff;

        &:hover {
            background: #bae7ff;
        }
    }

    .el-icon-message,
    .el-icon-phone {
        font-size: 21px;
        margin-left: 2px;
        color: #8e7777;
    }

    .centerRight .blue-back {
        font-size: 16px;
        color: #666666;
        padding-left: 10px;
    }

    .login-li {
        position: relative;
    }

    .login-li > i {
        width: 21px;
        height: 24px;
        position: absolute;
        left: 5px;
        bottom: 4px;
        z-index: 1;
        background-size: auto 80%;
    }

    .login-user {
        // background: url("../assets/images/icon-user1.png") no-repeat 50% 50%;
    }

    .login-pwd {
        // background: url("../assets/images/icon-pwd1.png") no-repeat 50% 50%;
    }

    .forget .el-form-item__content,
    .forget .el-form-item__error {
        padding-left: 105px;
    }

    .btn-li .el-form-item__content {
        padding: 0;
    }

    .forget .el-form-item__label {
        width: 95px;
        padding: 0;
        margin: 0;
        text-align: right;
    }

    .forget .message-btn {
        display: block;
        width: 120px;
        height: 36px;
        background: #3059fe;
        color: #fff;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
    }
}
</style>


